import React, { useContext, useEffect, useRef, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import MenuItem from "./menuItem.js"
import { ThemeContext } from "../../context/ThemeContext"

import "./style.scss"

const Menu = ({ menu }) => {
  const theme = useContext(ThemeContext)
  const [columns, setColumns] = useState(3)

  useEffect(() => {
    const query = window.matchMedia("(max-width: 1140px)")
    const updateColumns = () => setColumns(query.matches ? 2 : 3)
    updateColumns()
    query.addEventListener("change", updateColumns)
    return () => query.removeEventListener("change", updateColumns)
  }, [])

  const targetHeight = Math.ceil((menu?.children?.length || 0) / columns) * 90
  const targetHeightRef = useRef(targetHeight)
  const [height, setHeight] = useState(targetHeight)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    targetHeightRef.current = targetHeight
    // Keep enough space for the items that are still animating out.
    setHeight(currentHeight => Math.max(currentHeight, targetHeight))
  }, [targetHeight])

  useEffect(() => {
    // A column change does not trigger AnimatePresence's exit callback.
    setHeight(targetHeightRef.current)
  }, [columns])

  function close() {
    theme.setCurrentMenu(false)
  }

  return (
    <motion.ul
      initial={{ height: 0 }}
      animate={{ height }}
      transition={{ duration: 0.3 }}
      className={`${menu && menu.children ? "open" : "closed"}${
        isAnimating ? " animating" : ""
      }`}
      onAnimationStart={() => setIsAnimating(true)}
      onAnimationComplete={() => setIsAnimating(false)}
      onMouseLeave={close}
      id="submenu"
    >
      <AnimatePresence
        onExitComplete={() => setHeight(targetHeightRef.current)}
      >
        {(menu?.children || []).map((submenu, index) => (
          <MenuItem
            key={submenu?.id}
            index={index + 1}
            columns={columns}
            {...submenu}
          />
        ))}
      </AnimatePresence>
    </motion.ul>
  )
}

export default Menu
